// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__34tiL","search":"Input_search__RK8mv"};